import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function TrainingCard({ video, progress, t, onOpen }) {
  const percent = progress?.percentWatched || 0;
  const isComplete = Boolean(progress?.completedAt);
  const status = isComplete ? t.completed : percent > 0 ? t.inProgress : t.notStarted;

  return (
    <article className="training-card">
      <button type="button" className="training-thumbnail" onClick={() => onOpen(video.id)}>
        <img src={video.thumbnailUrl} alt="" />
        <span className="thumbnail-play"><SafeIcon icon={FiIcons.FiPlay} /></span>
        <small>{Math.ceil(video.durationSeconds / 60)} {t.minutes}</small>
      </button>
      <div className="training-card-body">
        <div className="training-card-topline">
          <span className="training-category">{video.category}</span>
          <span className={`language-badge ${video.language.toLowerCase()}`}>{video.language}</span>
        </div>
        <button type="button" className="training-title" onClick={() => onOpen(video.id)}>
          {video.title}
        </button>
        <p className="training-trainer">{t.trainer}: {video.trainer}</p>
        <div className="training-progress-label">
          <span>{status}</span>
          <strong>{percent}%</strong>
        </div>
        <div className="training-progress-track">
          <span style={{ width: `${percent}%` }} />
        </div>
        <div className="training-card-footer">
          <span>{new Date(video.publishedAt).toLocaleDateString()}</span>
          {isComplete && <SafeIcon icon={FiIcons.FiCheckCircle} className="completion-icon" />}
        </div>
      </div>
    </article>
  );
}

export default TrainingCard;